/**
 * Routes audio playback to platform-specific implementations.
 * iOS/iPadOS use Web Audio API and release the mic before TTS playback
 * to avoid playAndRecord routing audio to the earpiece at low volume.
 */

import { isAppleDevice } from "./deviceDetection";
import * as defaultPlayback from "./audioPlaybackManager.default";
import * as iosPlayback from "./audioPlaybackManager.ios";

const getImpl = () => (isAppleDevice() ? iosPlayback : defaultPlayback);

export const unlockAudioPlayback = () => {
  defaultPlayback.unlockAudioPlayback();
  if (isAppleDevice()) {
    iosPlayback.unlockAudioPlayback();
  }
};

export const getSharedAudioElement = () => getImpl().getSharedAudioElement();

export const playBase64MpegAudio = (base64, callbacks = {}) =>
  getImpl().playBase64MpegAudio(base64, callbacks);

export const stopAudioPlayback = () => {
  defaultPlayback.stopAudioPlayback();
  if (isAppleDevice()) {
    iosPlayback.stopAudioPlayback();
  }
};

export const releaseAudioPlayback = () => {
  defaultPlayback.releaseAudioPlayback();
  if (isAppleDevice()) {
    iosPlayback.releaseAudioPlayback();
  }
};
